export type StateEventParams = {
  stateEventType: string;
  stateEventArg?: string | number | boolean;
};
export type ButtonClickEventParams = {
  buttonText?: string;
  buttonVariant?: string;
  buttonSize?: string;
  buttonTrackingId?: string;
  buttonIndex?: number;
};
export type InputEventParams = {
  inputTrackingId?: string;
  inputLabel?: string;
  inputError?: string;
};
export type GameLaunchEventParams = { gameId?: string | number };
export type CategoryEventParams = {
  categoryId?: string | number;
  categoryTitle?: string;
};

export type RegistrationStepParams = {
  stepId: string;
  stepFields?: string;
};

export type RegistrationCompletedParams = {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  accountId: string;
  advertiserTrackingEnabled: string;
  applicationTrackingEnabled: string;
  extinfo: string[];
  installId?: string;
  fbc?: string;
};

export type TrackingParams =
  | StateEventParams
  | ButtonClickEventParams
  | InputEventParams
  | GameLaunchEventParams
  | CategoryEventParams
  | RegistrationStepParams
  | RegistrationCompletedParams;

export type ScreenView = {
  screenName: string;
  screenClass?: string;
  screenPath?: string;
  screenParams?: object;
};

export type TrackEvent = {
  name: `${TrackingEvents}`;
  params?: TrackingParams;
};

export enum TrackingEvents {
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  BUTTON_CLICK = 'button_click',
  INPUT_FOCUS = 'input_focus',
  INPUT_ERROR = 'input_error',
  HOME_WIDGET_CLICK = 'home_widget_click',
  CATEGORY_HOVER = 'category_hover',
  CATEGORY_CLICK = 'category_click',
  GAME_LAUNCH = 'game_launch',
  STATE_EVENT = 'state_event',
  SCREEN_VIEW = 'screen_view',
  REGISTRATION_STEP = 'registration_step',
  REGISTRATION_COMPLETED = 'registration_process_completed',
  WITHDRAW_BUTTON_CLICK = 'withdraw_button_click',
  DEPOSIT_BUTTON_CLICK = 'deposit_button_click',
}

export type InstallConversionData = {
  is_first_launch: 'true' | 'false';
  media_source: string;
  campaign: string;
  af_status: 'Organic' | 'Non-organic';
};

export type TrackingState = {
  installConversionData?: InstallConversionData;
  appsflyerUid?: string;
};
